// Re-labels the four process-dependent additional_field_N slots on WF / PWF
// transaction detail rows using the same mapping as the analytics prep
// (see analytics/prep/munis/shared/workflow/additional_fields.py).
//
// The backend stores these as generic columns because the meaning shifts per
// process: REQ rows carry req_*, PO* rows carry po_*, API rows carry invoice_*,
// and other processes leave them blank.

const ADDITIONAL_FIELD_COLUMNS = new Set([
  'additional_field_1',
  'additional_field_2',
  'additional_field_3',
  'additional_field_4'
])

const LABELS_BY_PROCESS = {
  REQ: ['Req Number', 'Req Ship Code', 'Req Status', null],
  POE: ['PO Number', 'PO Ship Code', 'PO Status', null],
  POM: ['PO Number', 'PO Ship Code', 'PO Status', null],
  API: ['Invoice Number', 'Invoice Department Code', 'Invoice Status', null]
}

const slotIndex = (databaseColumnName) => {
  const match = databaseColumnName.match(/^additional_field_(\d)$/)
  return match ? Number(match[1]) - 1 : -1
}

const findProcessTypeCode = (fields) => {
  const found = fields.find((f) => f.database_column_name === 'process_type_code')
  return found ? found.value : null
}

export const relabelAdditionalFields = (fields) => {
  if (!Array.isArray(fields)) return fields

  const processCode = findProcessTypeCode(fields)
  const labels = processCode && LABELS_BY_PROCESS[processCode]

  return fields.map((field) => {
    if (!ADDITIONAL_FIELD_COLUMNS.has(field.database_column_name)) return field

    const idx = slotIndex(field.database_column_name)
    const overrideLabel = labels && labels[idx]
    if (!overrideLabel) return field

    return { ...field, display_name: overrideLabel, name: overrideLabel }
  })
}
